import { ComponentItemDataStore } from "designSystem/utilities/component-item-functions";
import { Box, DataGridCardProps, DataGridSingleSelect, Text } from "designSystem/index";
import { ComponentItem } from "designSystem/types/component-item-types";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

const Card = (props: DataGridCardProps<ComponentItem>) => {
	const { item: { id, name } } = props;
	return (
		<Box>
			<Text text={name} />
		</Box>
	);
};

const data: ComponentItem[] = [];

for (let i = 0; i < 200; ++i) {
	data.push({
		id: i.toString(),
		name: `Item ${i}`,
	});
}

const store = new ComponentItemDataStore<ComponentItem>(data);

export default () => {
	const onSelectItem = (id?: string) => {
		alert(id);
	};

	/** determine how to get the text */
	const _getDisplayText = (id: string): string => {
		return data[id]?.name || "";
	};

	/** determine whether or not disable the item */
	const _getDisableItem = (item: ComponentItem) => {
		return new Set(["0", "1", "2"])
			.has(item.id);
	};

	return (
		<CssColumnGrid columns={3}>
			<Text semiBold text="Normal" />
			<Text semiBold text="Disable the component" />
			<Text semiBold text="Disable the options" />
			<DataGridSingleSelect<ComponentItem>
				GridCard={Card}
				getDisplayText={_getDisplayText}
				itemType="Test"
				onSelectItem={onSelectItem}
				store={store}
			/>
			<DataGridSingleSelect<ComponentItem>
				GridCard={Card}
				disabled
				getDisplayText={_getDisplayText}
				itemType="Test"
				onSelectItem={onSelectItem}
				store={store}
			/>
			<DataGridSingleSelect<ComponentItem>
				GridCard={Card}
				getDisableItem={_getDisableItem}
				getDisplayText={_getDisplayText}
				itemType="Test"
				onSelectItem={onSelectItem}
				store={store}
			/>
		</CssColumnGrid>
	);
};